import InputTypesEnum from '../../../Enums/InputTypesEnum';
import SurveyTransferMappingService from '../../../Services/SurveyTransferMappingService';
import SurveyTransferAnswerOptionMappingItem from '../../../Domain/SurveyTransferAnswerOptionMappingItem';

// GeneralEditPanelBase (Figma) description for editing a single answer-option rule: re-point the
// source answer option (searchable dropdown, empty = NULL). The selectable source answer options
// are attached to the edited item by the page as `SourceAnswerOptionOptions`
// (array of { value, text, secondaryId }). Reuses the same SourceQuestionSelect input.
export default class SurveyTransferAnswerOptionMappingPanelDescription {
  static itemType = SurveyTransferAnswerOptionMappingItem;
  static headerForEditPanel = 'Edit Answer Option Mapping';
  static headerForCreatePanel = 'Edit Answer Option Mapping';
  static labelForSubmitButton = 'Save';
  static nameOfTheIdField = 'SurveyTransferAnswerOptionMappingId';
  static icon = 'fa-solid fa-edit';
  static messageOnSuccess = 'The answer option rule has been saved.';

  static clickOnSubmitFunction = (editedItem) =>
    SurveyTransferMappingService.UpdateAnswerOptionMappingRule(
      editedItem.SurveyTransferAnswerOptionMappingId,
      editedItem.SourceTpAnswerOptionId
    );

  static fieldsInEditPanel = [
    {
      fieldName: 'TargetTpAnswerOptionText',
      label: 'Target Answer',
      className: 'col-12',
      type: InputTypesEnum.TextBoxReadOnly,
      numberOfRows: 3,
    },
    {
      fieldName: 'SourceTpAnswerOptionId',
      label: 'Source Answer',
      className: 'col-12',
      type: InputTypesEnum.SourceQuestionSelect,
      options: (editedItem) => editedItem.SourceAnswerOptionOptions,
      placeholder: 'Search and select a source answer option...',
      numberOfRows: 3,
    },
  ];
}
